<template>
  <div>
    <VueFileAgent
       ref="fileAgent"
      :multiple="true"
      :deletable="true"
      :meta="true"
      :accept="'image/*'"
      :maxSize="'400MB'"
      :maxFiles="maxFiles"
      :helpText="selectText"
      :errorText="{
        type: errorMessage,
        size: errorSize,
      }"
      :thumbnailSize="120"
      :theme="'list'"
       v-model="fileRecords"
       @select="filesSelected($event)"
       @input="fileInput($event)"
       @upload="fileUpload($event)"
       @beforedelete="onBeforeDelete($event)"
       @delete="onDelete($event)"
    ></VueFileAgent>


  </div>
</template>
<script>
import Axios from 'axios'
   export default {
    // ...
      data: function(){
         return {
              fileRecords: []
            , listFiles:[]
            , detail : {}
            , selectText :  "파일을 선택해주세요"
            , errorMessage : "이 형식은 이미지형식이 아닙니다."
            , errorSize : "사이즈가 400MB가 넘습니다."
            , maxFiles : 8
            , cnt : 0
         };
      },
      props:['listimgfile'],
      mounted:function(){
      //    // this.fileRecords = (this.listimgfile == null || this.listimgfile == undefined) ? [] : this.listimgfile;
      //    console.log("dragImg1 : ", this.listimgfile);
      //   if(this.listimgfile != null && this.listimgfile.length > 0){
      //      for(let i=0; i< this.listimgfile.length; i++){
      //          console.log("dragImg2 : ",this.listimgfile[i]);
      //          this.fileRecords.push(this.setFileRemindFromDB(this.listimgfile[i]));
      //          this.cnt++;
      //       }
      //   }

         let vm = this;

         if(vm.listimgfile != null && vm.listimgfile.length > 0){
            for(let i=0; i< vm.listimgfile.length; i++){
               vm.fileRecords.push(vm.setFileRemindFromDB(vm.listimgfile[i]));
               vm.cnt++;
            }
         }

         // if(vm.listimgfile.length > 0){
         //    for(let i=0; i< vm.listimgfile.length; i++){
         //       vm.fileRecords.push(vm.setFileRemindFromDB(vm.listimgfile[i]));
         //       vm.cnt++;
         //    }
         // }
      }
   , watch:{
      listimgfile:function(newVal, oldVal){
         let vm = this;
         vm.fileRecords = [];
         console.log("newVal : " + newVal);
         if(newVal.length > 0){
            for(let i=0; i< newVal.length; i++){
               vm.fileRecords.push(vm.setFileRemindFromDB(newVal[i]));
               vm.cnt++;
            }
         }
      }
   }
   , methods:{
          filesSelected(evt){
                let vm = this;
                if(evt.length == 0){

                }else{
                   for(let i=0; i<evt.length; i++){
                      if(evt[i].file.type.indexOf('image') > -1){
                        vm.cnt++;
                        vm.getUploadFiles(evt[i], vm.cnt);
                     }else{
                        continue;
                     }
                   }
                }
          },
          fileInput(evt){
          },
          fileUpload(evt){
          }


         ,onBeforeDelete(fileRecord){
             let vm = this;
            if(confirm('삭제하시겠습니까?')){
               //     if(fileRecord.file == null){
               //          let _inner = $("#fileKey").val();
               //          let _key = $("#fileKey").val();
               //          for(let i=0; i<this.fileRecords.length; i++){
               //             if(this.fileRecords[i].filePath === fileRecord.filePath){
               //                let _path = fileRecord.filePath.split("/");
               //                let _cnt = i+1;
               //                vm.getDelete(_cnt, _path[3], "new", fileRecord.fileKey);
               //             }
               //          }
               //     }else{
               //        if(fileRecord.file.type.indexOf('image') > -1){
               //          for(let i=0; i<this.fileRecords.length; i++){
               //              if(this.fileRecords[i].file.name === fileRecord.file.name){
               //                    let _cnt = i+1;
               //                   vm.getDelete(_cnt, fileRecord.file.name, "new");

               //              }
               //          }
               //       }
               //  }
               
               let _inner = $("#fileKey").val();
               let _key = $("#fileKey").val();
               for(let i=0; i<this.fileRecords.length; i++){
                  if(this.fileRecords[i].filePath === fileRecord.filePath){
                     let _path = fileRecord.filePath.split("/");
                     let _cnt = i+1;
                     vm.getDelete(_cnt, _path[3], "new", fileRecord.fileKey);
                  }
               }
               this.$refs.fileAgent.deleteFileRecord(fileRecord);
            }

        }
        , onDelete(evt){
        }
        ,getDelete(_cnt, _name, type, fileKey){
             let vm = this;
             let _form = new FormData();
             let _inner = (fileKey != null) ? fileKey : $("#fileKey").val();
             let _key = $("#fileKey").val();
             let usrKey = $("#usrKey").val();
             _form.append('paramUid', usrKey);
             _form.append('paramText', _name);
             _form.append('resultData', _cnt);
             _form.append('defaultView', _inner);
              _form.append('statusCode', type);

             Axios.post("/api/img/delete", _form, { headers: { 'Content-Type': 'multipart/form-data' }
             }).then(function(response) {
                  vm.cnt--;
            }).catch(function(ex) {
                console.log(ex);
            });
        }
        ,setFileRemindFromFile(_data){
           console.log(_data);
          return  {
              name : _data.file.name,
              sizeText :_data.sizeText,
              size : _data.size,
              type : _data.type,
              ext : _data.ext,
              width : _data.dimensions.width,
              height : _data.dimensions.height,
              color : _data.color
           };

        }
        ,setFileRemindFromDB(_data){
           console.log("_data",_data);
           return  {
              name : _data.file_org_name,
              sizeText :_data.sizeText,
              size : _data.size,
              type : _data.filetype,
              ext : _data.fileExt,
              filePath: '/img/' + _data.file_new_name.substring(0,8) + "/" + _data.file_new_name,
              //url: "http://localhost:8080/img/" + _data.file_new_name.substring(0,8) + "/" + _data.file_new_name,
              url: "/img/" + _data.file_new_name.substring(0,8) + "/" + _data.file_new_name,
              fileKey: _data.cmm_sprt,
              //urlResized: _data.imgBase64,
              lastModified: 1583992794341
           };
        }
        ,getUploadFiles(evt, cnt){
             let vm = this;
             let _inner = $("#fileKey").val();
             let _key = $("#fileKey").val();
             let _form = new FormData();
             let _data = vm.setFileRemindFromFile(evt);

             let _param = _data;

             _form.append('uploadFiles', evt.file);
             _form.append('paramText', _key);
             _form.append('resultData', vm.cnt);
             _form.append('defaultView', _inner);
             _form.append('reason', 'image');
             _form.append('paramOption', JSON.stringify(_param) );

              Axios.post("/api/img/upload", _form, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function(response) {

              }).catch(function(ex) {
                 console.log(ex);
              });
        }

        , onchanged(){
        }

        , onMaxChange(max){
            this.maxFiles = max;
        }
    }
  }
</script>
